/* ==========================================================================
   HAIKUTOKYO — motion layer

   Impulse already ships a scroll-in animation system (data-aos). A second
   reveal layer on top of it left sections stuck at opacity 0, so this file
   no longer hides anything. Motion that IS ours — hero ken-burns, nav
   underline, button fill, card and tile hovers — lives in haikutokyo.css.

   All that remains here is the hero scroll cue.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollCue() {
    var hero = document.querySelector('.template-index .slideshow-wrapper');
    if (!hero || hero.querySelector('.hk-scroll-cue')) return;

    var cue = document.createElement('button');
    cue.type = 'button';
    cue.className = 'hk-scroll-cue';
    cue.setAttribute('aria-label', 'Scroll to content');
    cue.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="square" aria-hidden="true"><path d="M5 9l7 7 7-7"/></svg>';

    cue.addEventListener('click', function () {
      var section = hero.closest('.shopify-section');
      var next = section && section.nextElementSibling;
      if (!next) return;
      next.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    });

    hero.appendChild(cue);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollCue);
  } else {
    initScrollCue();
  }

  document.addEventListener('shopify:section:load', initScrollCue);
})();
